module.exports = __webpack_public_path__ + "img/index09.e64774b7.jpg";